/**
 * @file bdtj.js 百度统计代码
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-11-29 Baidu
 */
export let setTongJiKey = userName => {
    // 登录后的key；21aa50f32ac4ec2548e78c74744a61e6
    // 未登录后的key：dccc0c79dec4ca8b022b2809427e6c4d
    let hmKey = userName ? '21aa50f32ac4ec2548e78c74744a61e6' : 'dccc0c79dec4ca8b022b2809427e6c4d';
    let bdtjScript = $('head>script').map((index, item) => {
        const hm = item.getAttribute('src') && item.getAttribute('src').match('hm.baidu.com');
        if (hm && hm[0] === 'hm.baidu.com') {
            return item;
        }
    });
    if (bdtjScript.length) {
        bdtjScript[0].setAttribute('src', `https://hm.baidu.com/hm.js?${hmKey}`);
    }
    else {
        let loginScript = document.createElement('script');
        loginScript.src = `https://hm.baidu.com/hm.js?${hmKey}`;
        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(loginScript, s);
    }
};

